import * as React from "react";
import ModalUI from "../ui/ModalUI";
import CustomButton from "../CustomButton";

export default function DialogBox({
  open,
  setClose, // model close
  onClick, // right button handler
  loading,
  bodyText = "Once you submit, you can no longer edit the entered values.",
  leftButtonTitle = "Go Back",
  submitButtonTitle = "Submit",
  title = "Are you sure?"
}) {
  return (
    <ModalUI show={open} handleClose={setClose} title= {title}>
      <p className="p4 text-center">{bodyText}</p>
      <div className="d-flex gap-3 mt-4">
        <CustomButton className="w-100" onClick={setClose} variant="outline">
          {leftButtonTitle}
        </CustomButton>
        <CustomButton className="w-100" onClick={onClick} loading={loading}>
        {loading ? "Processing..." : submitButtonTitle}
        </CustomButton>
      </div>
    </ModalUI>
  );
}
